import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'tipoRegiao'
})
export class TipoRegiao implements PipeTransform {

    transform(value: number): string {
        let regiao = '';
        switch (value) {
            case 1:
                regiao = 'Municipal';
                break;
            case 2:
                regiao = 'Metropolitano';
                break;
            case 3:
                regiao = 'Estadual';
                break;
            case 4:
                regiao = 'Federal';
                break;
        }
        return regiao;
    }
}
